<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="headline font-weight-bold ">Manage Academic Audits</v-subheader>
        </div>
      </v-col>
      <!-- <v-col v-if="modules.TeacherAuditListing" cols="12" sm="6" md="4" lg="3" >
        <router-link :to="{ name: 'listAudits' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-account" color="orange"
            cardTitle="Teacher Audits"> </clickable-card>
        </router-link>
      </v-col> -->

      <v-col v-if="modules.AuditListing" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'acadAudits', params: { type: 'All' } }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="All Academic Audits"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.Categories" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'listAuditCategory' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-sign-text" color="orange"
            cardTitle="Create Categories"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.AuditDrafts" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'auditDrafts' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-content-save-all-outline"
            color="orange" cardTitle="View Drafts"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.CenterListing" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'centerList' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-sign-text" color="orange"
            cardTitle="Center Wise Academic Audits"> </clickable-card>
        </router-link>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="4" lg="3" v-if="modules.auditScores">
        <router-link :to="{ name: 'auditScores' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-scoreboard" color="orange"
            cardTitle="Audit Scores"> </clickable-card>
        </router-link>
      </v-col> -->
      <!-- <v-col cols="12" sm="6" md="4" lg="3" >
        <router-link :to="{ name: 'acadAudits', params: { type: 'online' }}">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Online Audit"> </clickable-card>
        </router-link>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" >
        <router-link :to="{ name: 'acadAudits', params: { type: 'offline' }}">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Offline Audit"> </clickable-card>
        </router-link>
      </v-col> -->
    </v-row>
  </v-container>
</template>
<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'

export default {
  name: 'auditMaster',
  components: { ClickableCard },
  data () {
    return {
      modules: {
        AuditDrafts: this.checkModuleAccess('AuditDrafts'),
        CenterListing: this.checkModuleAccess('CenterListing'),
        AuditListing: this.checkModuleAccess('AuditListing'),
        TeacherAuditListing: this.checkModuleAccess('TeacherAuditListing'),
        Categories: this.checkModuleAccess('Categories')
      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  },
  async created () {
    console.log(this.modules)
  }
}
</script>
